import script from "./CapturadorFoto.vue?vue&type=script&setup=true&lang=js"
export * from "./CapturadorFoto.vue?vue&type=script&setup=true&lang=js"

import "./CapturadorFoto.vue?vue&type=style&index=0&id=8406bb06&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8406bb06"]])

export default __exports__